<template>
    <div class="cadastral-units-map-field" style="display: block; width: 100%; height: 100%;">
        <input type="hidden" :name="name" :value="selectedIdsString" ref="hiddenField"/>
        <div class="map-container" style="width: 100%; height: 100%;">
            <CadastralUnitsMap
                :center="center"
                :loadPointsUrl="loadPointsUrl"
                :initialSelectedIds="value"
                :useGeolocation="useGeolocation"
                @selection-changed="handleSelectionChange"/>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent, PropType, ref} from 'vue';
import CadastralUnitsMap from './CadastralUnitsMap.vue';

interface Coordinates {
    readonly latitude: number;
    readonly longitude: number;
}

export default defineComponent({
    components: {
        CadastralUnitsMap,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        center: {
            type: Object as PropType<Coordinates>,
            required: true,
        },
        loadPointsUrl: {
            type: String,
            required: true,
        },
        value: {
            type: String,
            default: '',
        },
        useGeolocation: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['selection-changed'],
    setup(props, {emit}) {
        const hiddenField = ref<HTMLInputElement | null>(null);
        const selectedIdsString = ref(props.value);

        function handleSelectionChange(selectedIds: string[]): void {
            selectedIdsString.value = selectedIds.join(',');

            emit('selection-changed', selectedIds);

            // Trigger change event for form frameworks
            const event = new Event('change', {bubbles: true});
            hiddenField.value!.dispatchEvent(event);
        }

        return {hiddenField, selectedIdsString, handleSelectionChange};
    },
});
</script>

<style scoped>
.cadastral-units-map-field {
    display: block;
    width: 100%;
    height: 100%;
}

.map-container {
    width: 100%;
    height: 100%;
}
</style>
